import React from "react";
import { NavLink, useLocation } from "react-router";
import {
  Header,
  HeaderBrand,
  HeaderBurgerMenu,
  HeaderNavigation,
  HeaderSkipLinks,
  SkipLink,
  NavItem,
} from "@flixbus/honeycomb-react";
import { LoginWidget } from "@/pages/Login";
import { basePath } from "@/pages/Login/auth.config";
import { routePaths } from "@/constants/routePaths";
import flixTrackwiseLogo from "../assets/flix-trackwise-logo.svg";
import styles from "./AppHeader.module.scss";

const isRouteActive = (pathname: string, routePath: string): boolean =>
  pathname === routePath || pathname.startsWith(`${routePath}/`);

const AppNavigation: React.FC<{ isBurger?: boolean }> = ({ isBurger }) => {
  const { pathname } = useLocation();
  return (
    <HeaderNavigation aria-label="Main">
      <NavItem
        RouterLink={NavLink}
        to={routePaths.calculations}
        active={isRouteActive(pathname, routePaths.calculations)}
        shouldCloseDialog={isBurger}
      >
        Calculations
      </NavItem>
      <NavItem
        RouterLink={NavLink}
        to={routePaths.calculationAnalysis}
        active={isRouteActive(pathname, routePaths.calculationAnalysis)}
        shouldCloseDialog={isBurger}
      >
        Calculation Analysis
      </NavItem>
      <NavItem
        RouterLink={NavLink}
        to={routePaths.operationalData}
        active={isRouteActive(pathname, routePaths.operationalData)}
        shouldCloseDialog={isBurger}
      >
        Operational Data
      </NavItem>
    </HeaderNavigation>
  );
};

const AppHeader: React.FC<{ displayNavigation: boolean }> = ({
  displayNavigation,
}) => {
  return (
    <Header
      extraClasses={styles.header}
      skipLinks={
        <HeaderSkipLinks>
          <SkipLink to="main-content">Skip to main content</SkipLink>
        </HeaderSkipLinks>
      }
      brand={
        <HeaderBrand
          alt="TrackWise Home"
          href={basePath}
          src={flixTrackwiseLogo}
          height="30"
          width="230"
          extraClasses={styles.brand}
        />
      }
      navigation={displayNavigation && <AppNavigation />}
      burgerMenu={
        displayNavigation && (
          <HeaderBurgerMenu
            openPanelLabel="Open menu"
            closePanelLabel="Close menu"
            panelId="burger-panel"
          >
            <AppNavigation isBurger />
          </HeaderBurgerMenu>
        )
      }
      widgets={<LoginWidget extraClasses={styles.widgets} />}
    />
  );
};

export default React.memo(AppHeader);
